exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Guest__guest___36BXH {\n  padding-bottom: 24px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  margin: 0 12px;\n  width: 245px;\n}\n\n.Guest__section___2cSKe {\n  margin-top: 12px;\n}\n\n.Guest__header___2W6yH {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Guest__input___1YtR9 {\n  margin-top: 4px;\n}\n\n.Guest__textInput___1YSK2 {\n  border: 1px solid #d6dee7;\n  color: rgba(34, 34, 34, 1);\n  font-size: 18px;\n  padding: 4px 8px;\n  margin: 0;\n}\n\n.Guest__textInput___1YSK2:first-child {\n  border-right: none;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  width: 105px;\n}\n\n.Guest__textInput___1YSK2:last-child {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  width: 140px;\n}\n\n.Guest__diet___2hfHr .Guest__textInput___1YSK2 {\n  border-radius: 4px;\n  font-size: 14px;\n  margin-top: 12px;\n  padding: 8px;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"guest": "Guest__guest___36BXH",
	"section": "Guest__section___2cSKe",
	"header": "Guest__header___2W6yH",
	"input": "Guest__input___1YtR9",
	"textInput": "Guest__textInput___1YSK2",
	"diet": "Guest__diet___2hfHr"
};